import { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import MuiLink from '@mui/material/Link';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import BasicLayout from 'layouts/authentication/components/BasicLayout';
//import bgImage from "assets/images/bg-sign-in-basic.jpg";
import bgImage from 'assets/images/loginbg.png';
import { apiLogin } from '../../../api/auth.api';
import { useData } from '../../../hooks/';
import { useNavigate } from 'react-router-dom'; // 추가

function Basic() {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // 추가
  const { saveUser } = useData();

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const userResponse = await apiLogin({ userid, password });

      // 사용자 정보 저장
      saveUser(userResponse.data);

      // 토큰 저장 (백엔드에서 accessToken 반환)
      if (userResponse.data.accessToken) {
        localStorage.setItem('access_token', userResponse.data.accessToken);
        console.log(
          '✅ 토큰이 저장되었습니다:',
          userResponse.data.accessToken.substring(0, 20) + '...',
        );
      } else {
        console.warn(
          '⚠️ 백엔드 응답에 accessToken이 없습니다:',
          userResponse.data,
        );
      }

      console.log('로그인 응답:', userResponse.data);
      navigate('/boards');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant='gradient'
          bgColor='info'
          borderRadius='lg'
          coloredShadow='info'
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign='center'
        >
          <MDTypography variant='h4' fontWeight='medium' color='white' mt={1}>
            로그인
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component='form' role='form' onSubmit={onSubmit}>
            <MDBox mb={2}>
              <MDInput
                type='text'
                label='아이디'
                fullWidth
                value={userid}
                onChange={(e) => setUserid(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type='password'
                label='비밀번호'
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant='gradient' color='info' fullWidth type='submit'>
                로그인
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
